import IndustryList from './IndustryList';

export default IndustryList;
